<template>
  <div class="container txt-black full">
    <div v-if="user">
      <div class="flex items-center space-x-3">
        <div>
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.58 11.4709C15.0345 10.9028 15.2846 10.1984 15.29 9.4709C15.29 8.59834 14.9434 7.76151 14.3264 7.14452C13.7094 6.52752 12.8726 6.1809 12 6.1809C11.1274 6.1809 10.2906 6.52752 9.67362 7.14452C9.05662 7.76151 8.71 8.59834 8.71 9.4709C8.71542 10.1984 8.96551 10.9028 9.42 11.4709C8.52863 12.0133 7.8293 12.8211 7.42 13.7809C7.36271 13.9027 7.3306 14.0348 7.32558 14.1693C7.32056 14.3037 7.34274 14.4379 7.39079 14.5636C7.43884 14.6893 7.51177 14.804 7.60521 14.9009C7.69865 14.9977 7.81068 15.0747 7.93459 15.1272C8.0585 15.1798 8.19174 15.2067 8.32632 15.2066C8.4609 15.2064 8.59406 15.179 8.71782 15.1261C8.84157 15.0732 8.95338 14.9959 9.04655 14.8988C9.13971 14.8017 9.21231 14.6867 9.26 14.5609C9.48983 14.0236 9.87157 13.5652 10.3583 13.2419C10.8451 12.9186 11.4157 12.7444 12 12.7409C12.586 12.7425 13.1588 12.9157 13.6475 13.2392C14.1362 13.5626 14.5195 14.0221 14.75 14.5609C14.8266 14.7416 14.9546 14.8959 15.1182 15.0043C15.2818 15.1128 15.4737 15.1707 15.67 15.1709C15.8038 15.1684 15.936 15.1413 16.06 15.0909C16.3039 14.9873 16.4966 14.7912 16.596 14.5455C16.6954 14.2999 16.6932 14.0249 16.59 13.7809C16.1781 12.8196 15.4751 12.0117 14.58 11.4709ZM12 10.7409C11.7444 10.7409 11.4946 10.665 11.2823 10.5228C11.0699 10.3806 10.9046 10.1785 10.8073 9.94222C10.7099 9.70592 10.685 9.44604 10.7356 9.19553C10.7862 8.94503 10.91 8.71519 11.0914 8.53519C11.2728 8.35518 11.5036 8.23312 11.7545 8.18448C12.0054 8.13584 12.2651 8.16282 12.5006 8.26199C12.7362 8.36116 12.9369 8.52806 13.0775 8.74151C13.218 8.95496 13.292 9.20534 13.29 9.4609C13.2874 9.80129 13.1503 10.1268 12.9087 10.3666C12.667 10.6064 12.3404 10.7409 12 10.7409ZM18 2.1709H6C5.20435 2.1709 4.44129 2.48697 3.87868 3.04958C3.31607 3.61219 3 4.37525 3 5.1709V16.1709C3 16.9665 3.31607 17.7296 3.87868 18.2922C4.44129 18.8548 5.20435 19.1709 6 19.1709H8.59L11.29 21.8809C11.3834 21.9736 11.4943 22.0469 11.6161 22.0967C11.7379 22.1464 11.8684 22.1717 12 22.1709C12.2383 22.1709 12.4689 22.0858 12.65 21.9309L15.87 19.1709H18C18.7956 19.1709 19.5587 18.8548 20.1213 18.2922C20.6839 17.7296 21 16.9665 21 16.1709V5.1709C21 4.37525 20.6839 3.61219 20.1213 3.04958C19.5587 2.48697 18.7956 2.1709 18 2.1709ZM19 16.1709C19 16.4361 18.8946 16.6905 18.7071 16.878C18.5196 17.0655 18.2652 17.1709 18 17.1709H15.5C15.2617 17.1709 15.0311 17.256 14.85 17.4109L12.05 19.8109L9.71 17.4609C9.61656 17.3682 9.50574 17.2949 9.38391 17.2451C9.26207 17.1954 9.13161 17.1701 9 17.1709H6C5.73478 17.1709 5.48043 17.0655 5.29289 16.878C5.10536 16.6905 5 16.4361 5 16.1709V5.1709C5 4.90568 5.10536 4.65133 5.29289 4.46379C5.48043 4.27626 5.73478 4.1709 6 4.1709H18C18.2652 4.1709 18.5196 4.27626 18.7071 4.46379C18.8946 4.65133 19 4.90568 19 5.1709V16.1709Z"
              fill="#20419B"
            />
          </svg>
        </div>
        <div class="fs-22 fw-500">{{user.name}}</div>
        <!-- <span v-if="isImgPackage"><img
            class="h-9"
            :src="getUrlImg(isImgPackage)"
            alt=""
          /></span>
        <div
          v-else-if="isPendingOrder"
          class="bg-pending-order"
        > Đang chờ xác nhận </div> -->
      </div>
      <div class="fs-16 fw-400 my-2">
        {{getInfo()}}
      </div>
    </div>
    <!-- // -->
    <div class="row mt-3">
      <div class="col-md-4 flex flex-col items-center text-center space-y-10 text-pri-900 fs-16 fw-500">
        <div class=""><img
            src="../../assets/icon/SKB.svg"
            alt=""
          >
          <div>Sổ khám bệnh</div>
        </div>
      </div>
      <div class="col-md-8">
        <p
          class="fs-28 fw-500 mb-3"
          v-if="!loading"
        >Danh sách Sổ Khám Bệnh</p>
        <div
          v-if="hr.length === 0"
          class="text-gray-400 flex justify-center"
        >
          Chưa có sổ khám bệnh
        </div>
        <div
          class="height-60vh"
          v-loading="loading"
        >
          <div
            class="item"
            v-for="item in hr"
            :key="item.id"
          >
            <div class="d-flex justify-between items-center -mb-6">
              <div class="flex">
                <div class="me-2">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 4.25C16 5.49 14.99 6.5 13.75 6.5H10.25C9.63 6.5 9.07 6.25 8.66 5.84C8.25 5.43 8 4.87 8 4.25C8 3.01 9.01 2 10.25 2H13.75C14.37 2 14.93 2.25 15.34 2.66C15.75 3.07 16 3.63 16 4.25Z"
                      fill="#476DD6"
                    />
                    <path
                      d="M18.83 5.02996C18.6 4.83996 18.34 4.68996 18.06 4.57996C17.77 4.46996 17.48 4.69996 17.42 4.99996C17.08 6.70996 15.57 7.99996 13.75 7.99996H10.25C9.25 7.99996 8.31 7.60996 7.6 6.89996C7.08 6.37996 6.72 5.71996 6.58 5.00996C6.52 4.70996 6.22 4.46996 5.93 4.58996C4.77 5.05996 4 6.11996 4 8.24996V18C4 21 5.79 22 8 22H16C18.21 22 20 21 20 18V8.24996C20 6.61996 19.55 5.61996 18.83 5.02996ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z"
                      fill="#476DD6"
                    />
                  </svg>

                </div>
                <div>
                  <p
                    @click="goToDetail(item.id)"
                    class="fs-18 fw-500 txt-black mb-1 max-max-line-3 cursor-pointer"
                  >{{ 'Mã SKB: ' + item.code }}</p>
                  <p class="fs-18 fw-500 txt-black mb-1 max-max-line-2 ">{{ getCSYT(item) }}</p>
                  <p class="fs-18 fw-400 txt-black mb-1 max-max-line-1 ">{{ item.visit_reason }}</p>
                </div>
              </div>
              <div class="flex space-x-5">
                <div
                  class="d-flex flex-col justify-content-end align-items-center w-20"
                  @click="goToDetail(item.id)"
                >
                  <svg
                    width="29"
                    height="29"
                    viewBox="0 0 29 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.625651"
                      y="1.01969"
                      width="27.4167"
                      height="27.4167"
                      rx="13.7083"
                      stroke="#20419B"
                      stroke-width="0.583333"
                    />
                    <path
                      d="M8.20898 14.1447C7.88682 14.1447 7.62565 14.4059 7.62565 14.728C7.62565 15.0502 7.88682 15.3114 8.20898 15.3114V14.1447ZM20.2881 15.1405C20.5159 14.9127 20.5159 14.5434 20.2881 14.3155L16.5758 10.6032C16.348 10.3754 15.9787 10.3754 15.7509 10.6032C15.5231 10.831 15.5231 11.2004 15.7509 11.4282L19.0507 14.728L15.7509 18.0279C15.5231 18.2557 15.5231 18.625 15.7509 18.8528C15.9787 19.0806 16.348 19.0806 16.5758 18.8528L20.2881 15.1405ZM8.20898 15.3114H19.8757V14.1447H8.20898V15.3114Z"
                      fill="#002496"
                    />
                  </svg>
                  <p class="fs-12 fw-400 txt-pri mb-0 me-2">Xem chi tiết</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import moment from 'moment'
export default {
  name: 'HealthRecords',
  data () {
    return {
      hr: [],
      user: null,
      loading: false
    }
  },
  // computed: {
  //   isMemberPackage () {
  //     const redeemPackage = this.user?.redeem_package
  //     if (redeemPackage) {
  //       return redeemPackage
  //     }
  //     const packages = this.user?.user_packages || []
  //     const result = packages?.find(item => {
  //       return item.member_package?.code.toUpperCase() === 'HODO GOLD' || item.member_package?.code.toUpperCase() === 'HODO GOLD PLUS' || item.member_package?.code.toUpperCase() === 'HODO SILVER PLUS'
  //     })
  //     return result
  //   },
  //   isImgPackage () {
  //     const pac = this.user?.redeem_package
  //     if (pac) {
  //       return pac.package_icon
  //     }
  //     const packages = this.user?.user_packages || []
  //     let result = packages?.find(item => {
  //       return item.member_package?.code.toUpperCase() === 'HODO GOLD' || item.member_package?.code.toUpperCase() === 'HODO GOLD PLUS'
  //     })
  //     if (!result) {
  //       result = packages?.find(item => {
  //         return item.member_package?.code.toUpperCase() === 'HODO SILVER PLUS'
  //       })
  //     }
  //     return result && result.member_package?.package_icon
  //   },
  //   isPendingOrder () {
  //     return this.user?.is_pending_order
  //   }
  // },
  mounted () {
    const self = this
    self.getHealthRecords()
    self.user = this.$user
  },
  methods: {
    async getHealthRecords () {
      const self = this
      this.loading = true
      const params = {
        limit: 100,
        sort: 'created_at',
        sort_by: 'desc'
      }
      await self.$rf
        .getRequest('AuthRequest')
        .getHealthRecords(params)
        .then((resp) => {
          self.hr = resp?.data || null
          console.log(resp)
        })
        .catch((e) => {
          console.log(e)
        }).finally(() => {
          this.loading = false
        })
    },
    getInfo () {
      let result = ''
      if (this.user.person?.birthday) result = `Ngày sinh: ${moment(this.user.person.birthday).format('DD/MM/YYYY')}`
      if (this.user.person?.phone) result = `${result}, SĐT: ${this.user.person.phone}`
      if (this.user.person?.address) result = `${result}, Đ/C: ${this.user.person.address}`
      return result
    },
    getCSYT (item) {
      if (item?.clinic?.organization?.name) {
        return item?.clinic?.organization?.name
      } else {
        return item?.clinic?.name
      }
    },
    getUrlImg (path) {
      return appUtils.getDocumentURL(path)
    },
    goToHR () {
      this.$router.push({ name: 'HealthRecords' })
    },
    goToDetail (id) {
      this.$router.push({ path: `/health-records/${id}` })
    }
  }
}
</script>

  <style scoped>
.full {
  min-height: calc(100vh - 150px);
}
.item {
  width: 100%;
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  cursor: pointer;
}
.btn-add {
  height: 70px;
  width: 100%;
  border: 1px dashed #20409b;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px;
  cursor: pointer;
}
.bg-pending-order {
  background: #ffbc99;
  border-radius: 16px;
  padding: 0 12px;
  color: black;
  font-size: 14px;
  font-weight: 500;
}
.height-60vh {
  height: 60vh;
  overflow: auto;
}
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
</style>
